import Vue from 'vue';

export function ellipsisFilter(text: string | null, maxCharacters: number): string {
  if (maxCharacters <= 3) {
    return '...'.substr(0, maxCharacters);
  }

  if (!text) {
    return '';
  }

  return text.length > maxCharacters ? `${text.substr(0, maxCharacters - 3)}...` : text;
}

Vue.filter('ellipsis', ellipsisFilter);
